import type { GeneratedColumn } from "building-types/columns/columnGeneratedTypes";
import type { Column } from "building-types/columns/columnTypes";
import type { ColumnCatalogSettings } from "building-types/settings/columnCatalogSettings";
import type { Table } from "common/data/table";

export function generatedColumnHeight(column: GeneratedColumn): number {
  let totalHeight = 0;
  for (const extrusion of column.extrusions) {
    totalHeight += Math.abs(extrusion.dirZ);
  }
  return totalHeight;
}

export function resolveColumnName(
  column: GeneratedColumn,
  docColumns: Table<Column>,
  columnSettings: ColumnCatalogSettings,
): string {
  const docColumn = docColumns[column.handle.id];
  if (!docColumn) {
    return "";
  }
  const descriptor = columnSettings.columnTable[docColumn.catalogColumnId];
  return descriptor?.name ?? "";
}
